import React from "react";
import SearchFilter from "components/searchFilter";
import useTranslation from "utils/hooks/useTranslation";

interface IPropsSearchFilterProcess {
  processUpdateFilter: (...args) => void;
  processChangeFieldValue: (...args) => void;
}

const ProcessFilter = ({ processUpdateFilter, processChangeFieldValue }: IPropsSearchFilterProcess) => {
  const SEARCH_PLACEHOLDER = `${useTranslation({
    id: "search_process",
  })}...`;

  return <SearchFilter placeholder={SEARCH_PLACEHOLDER} updateFilter={processUpdateFilter} changeFieldValue={processChangeFieldValue} numbersTypedCharacters={3} />;
};

export default ProcessFilter;
